<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <div class="active-campaigns d-flex align-items-center alert alert-success">
                    <h4>Active Campaigns ------</h4>
                    <p class="p3n ml-2 mt-1">
                        <b>InDemand: </b> {{campaignsCounts.indemand}},
                        <b>Upcoming: </b> {{campaignsCounts.upcoming}},
                        <b>Live: </b> {{campaignsCounts.live}}
                    </p>
                </div>
                <h4 class="mr-2">Filters</h4>
                <div class="d-flex align-items-center mb-3">
                    <div>
                        <b-form-select 
                            v-if="users.length" 
                            v-model="selectedUser" 
                            value-field="userId"
                            :options="users" text-field="email">
                            <template #first>
                                <b-form-select-option :value="null">-- All Users --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <div class="ml-3">
                        <b-form-select 
                            v-if="profileStatuses" 
                            v-model="profileStatus" 
                            :options="profileStatuses">
                             <template #first>
                                <b-form-select-option :value="null">-- Profile Status --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
                <div class="d-flex flex-wrap">
                     <label 
                        class="checkbox-content" 
                        v-for="filter in filtersData"
                        :key="filter.key">
                        {{filter.text}} ({{campaignsCounts[filter.key]}})
                        <input type="checkbox" v-model="filters[filter.key]">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <button class="btn btn-info mx-3" @click="resetFilters">Reset Filters</button>
            <button id="export" class="btn btn-success" @click="tableToExcel('table', 'campaign table')">Export Table</button>
        </div>
        <div class="mt-4 table-holder">
            <table ref="table" id="loremTable" class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">Id</th>
                        <th class="text-center">Camp Title</th>
                        <th class="text-center">Owner Profile Status</th>
                        <th class="text-center">Owner Email</th>
                        <th class="text-center">Featured</th>
                        <th class="text-center">Hidden</th>
                        <th class="text-center">Badge</th>
                        <th class="text-center">Indemand</th>
                        <th class="text-center">Manage community permission</th>
                    </tr>
                </thead>
                <TableRow
                    v-for="campaign in filterUsers" 
                    :key="`campaign-${campaign.id}`"
                    @updateCampaign = 'updateCampaign'
                    :campaign="campaign"/>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { db, ADMINS } from '../../../firebase'
import TableRow from './TableRow'
const filtersInitialState =  {
    featured: false,
    hidden: false,
    manageCommunityAccess: false,
    indemand: false
}


export default {
    name: 'CampsPanel',
    components: {
        TableRow,
    },
    data() {
        return {
            selectedUser: null,
            profileStatus: null,
            campaigns: [],
            profileStatuses: [
                {value: '', text: 'Has no status'},
                {value: 'subscribed', text: 'Subscribed'},
                {value: 'subscription canceled', text: 'Subscription Canceled'},
                {value: 'trial expired', text: 'Trial expired'},
                {value: 'trial', text: 'Is in trial'}
            ],
            filtersData: [
                {key: 'featured', text: 'Featured Campaigns'},
                {key: 'hidden', text: 'Hidden Campaigns'},
                {key: 'indemand', text: 'InDemand Campaigns'},
                {key: 'crosspromoter', text: 'Has Crosspromoter Badge'},
                {key: 'manageCommunityAccess', text: 'Campaigns with Manage Community Access'},
            ],
            users: [],
            emails: {},
            userId: null,
            filters: {...filtersInitialState},
            uri :'data:application/vnd.ms-excel;base64,',
            template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
            format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
        }
    },
    computed: {
        ...mapState([
            'user',
            'serverTime'
        ]),
        filteredCampaigns(){

            if(Object.values(this.filters).every(item => !item)) {
                return null
            }

            return this.campaigns.filter(item => {

                let condition = ''

                if(this.filters['hidden']) {
                    condition = item.hidden
                }

                if(this.filters['featured']) {
                    condition = condition !== '' ? (condition &&  item.featured) : item.featured
                }

                if(this.filters['indemand']) {
                    condition = condition !== '' ? (condition &&  item.indemand) : item.indemand
                }

                if(this.filters['crosspromoter']) {
                    condition = condition !== '' ? (condition &&  item.crosspromoter) : item.crosspromoter
                }

                if(this.filters['manageCommunityAccess']) {
                    condition = condition !== '' ? (condition &&  item.manageCommunityAccess) : item.manageCommunityAccess
                }

                return !!condition
            })
        },
        filterUsers: function() {

            let campaigns = this.filteredCampaigns || this.campaigns

            if(this.selectedUser) {
                campaigns = campaigns.filter(
                    (camp) => camp.author_id === this.selectedUser
                )
            }

            if(this.profileStatus !== null) {
                campaigns = campaigns.filter(
                    (camp) => camp.profileStatus == this.profileStatus
                )
            }

            return campaigns
        },
        campaignsCounts(){

            let indemand = 0; 
            let upcoming = 0;
            let live = 0;
            let featured = 0;
            let manageCommunityAccess = 0;
            let hidden = 0;
            let crosspromoter = 0;
            
            this.filterUsers.forEach(item => {
                if(item.indemand && !item.hidden) {
                    indemand++
                }

                if(!item.indemand && item.state === 'live' && !item.hidden) {
                    live++
                }

                if(item.state === 'upcoming' && !item.hidden) {
                    upcoming++
                }

                if(item.featured) {
                    featured++
                }

                if(item.manageCommunityAccess) {
                    manageCommunityAccess++
                }

                if(item.crosspromoter) {
                    crosspromoter++
                }

                if(item.hidden) {
                    hidden++
                }

            })

            return {
                indemand, 
                upcoming, 
                live,
                hidden,
                featured,
                manageCommunityAccess,
                crosspromoter
            }

           
        }
    },
    mounted: function() {
        if(ADMINS.includes(this.user.uid)) {
            this.getUsers()
            return
        }
        return this.$router.push('/').catch(()=>{})

    },
    methods: {
        async updateCampaign(id, field, value) {
            const changedCampaignIndex = this.campaigns.findIndex(item => item.id === id)
            const changedCampaign = this.campaigns.find(item => item.id === id)

            this.campaigns.splice(changedCampaignIndex, 1, { 
                ...changedCampaign,
                [field]: value
            })

        },
        resetFilters(){
            this.selectedUser = null;
            this.profileStatus = null;
            this.filters = {...filtersInitialState};
        },
        tableToExcel(table, name){
            if (!table.nodeType) table = this.$refs.table
            let ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            window.location.href = this.uri + this.base64(this.format(this.template, ctx))
        },
        getUsers: function() {
            db
                .collection('Users')
                .get()
                .then(user => {

                    this.users = user.docs.map(
                        (doc) => {
                            return {
                                ...doc.data(),
                            }
                        }
                    )

                    this.emails = this.users.reduce(
                        
                        (prev, next) => {

                            const profileStatus = next.premiumPlan && next.premiumPlan.status === 'active' ? 'premium plan' : 'basic plan'

                            return { 
                            ...prev, 
                            [next.userId]: {
                                email: next.email,
                                profileStatus: profileStatus
                            }}
                        }, {}
                    )

                    this.getCampaigns()
                })
        },
        getCampaigns: function() {
            db
                .collection('campaigns')
                .get()
                .then(camp => {
                    this.campaigns = camp.docs.map(
                        (doc, index) => {
                            const data = doc.data()
                            return {
                                ...data,
                                email: this.emails[data.author_id] && this.emails[data.author_id].email,
                                profileStatus: this.emails[data.author_id] && this.emails[data.author_id].profileStatus,
                                index,
                                id: doc.id
                            }
                        }
                    )
                })
        }
    }

}
</script>


<style lang="scss" scoped>
    /* Customize the label (the container) */
.checkbox-content {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-right: 40px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-content input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fff;
    box-shadow: inset 0 0 2px 0;
}

// /* On mouse-over, add a grey background color */
// .checkbox-content:hover input ~ .checkmark {
//   background-color: #ccc;
// }

/* When the checkbox is checked, add a blue background */
.checkbox-content input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-content input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-content .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


</style>